'use strict';

angular.module('gov.services', []);